/*
  Expected URI pattern:
    /:brand/users/:id/permissions/:id/channels/:id
  E.g:
    /times/users/123/permissions/ngo_market/channels/email
 */
import fetch from 'unfetch';
import _ from 'lodash';

class PermissionAPI {
  constructor(brand, config = {}) {
    config = {
      ...{
        baseUri: '/api',
        fetchAdapter: fetch,
        clientVersion: null
      },
      ...config
    };
    if (!config.clientVersion) {
      throw new Error('REACT_APP_GITHASH must be set');
    }
    this.baseUri = config.baseUri;
    this.brand = brand;
    this.fetch = config.fetchAdapter;
    this.clientVersion = config.clientVersion;
  }
  static errorHandler(resp) {
    // @todo need to reject with a useful error message
    // - We need to standardise the error responses from the api.
    //   Atm fetch doesn't see 400 errors as a fail, but resp.ok is false.
    //   For the thrown error to be useful to the FE we need a standard error to
    //   parse for details to show the user.
    return resp.ok
      ? Promise.resolve(resp)
      : Promise.reject(new Error('Something went wrong'));
  }
  requestMagicLink = (email) =>
    this.fetch(`${this.baseUri}/auth/request-login-email`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },
      body: JSON.stringify({ email, brand: this.brand })
    }).then(this.errorHandler);
  getSessionToken = (tokenType, authToken) => {
    let endpoint = `${this.baseUri}/auth/validate`;
    let body = ``;

    switch (tokenType) {
      case 'email':
        endpoint = `${endpoint}/email-token`;
        body = `token=${authToken}`;
        break;
      case 'guid':
        endpoint = `${endpoint}/guid`;
        body = `guid=${authToken}&brand=${this.brand}`;
        break;
      default:
        throw new Error('Must specify auth tokenType');
    }

    return this.fetch(endpoint, {
      method: 'post',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      credentials: 'include',
      body
    }).then(this.errorHandler);
  };
  getUserPermissions = () =>
    this.fetch(`${this.baseUri}/permissions`, {
      credentials: 'include'
    }).then(this.errorHandler);
  getUserPermissionById = (permissionId) =>
    this.fetch(`${this.baseUri}/permissions/${permissionId}`, {
      credentials: 'include'
    }).then(this.errorHandler);
  getPartners = () =>
    this.fetch(`${this.baseUri}/partners`, {
      credentials: 'include'
    }).then(this.errorHandler);
  setUserPermission = (permission, channel, allowed, userPermission) =>
    this.fetch(
      `${this.baseUri}/permissions/${permission.id}/user-permissions`,
      {
        method: 'post',
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        },

        credentials: 'include',
        body: JSON.stringify({
          channel,
          allowed,
          cpn: userPermission.cpn,
          email: userPermission.email,
          partyId: userPermission.partyId,
          scv: userPermission.scv,
          naturalKey: userPermission.naturalKey,
          naturalKeySource: userPermission.naturalKeySource,
          customerUid: userPermission.customerUid,
          clientVersion: this.clientVersion,
          permissionCopyVersion:
            permission.permissionCopyVersion || 'DATA_ERROR_MISSING_VERSION'
        })
      }
    ).then(this.errorHandler);
  setGlobalPermission = (userPermissions, allowed) =>
    this.fetch(`${this.baseUri}/permissions/toggle`, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json; charset=utf-8'
      },

      credentials: 'include',
      body: JSON.stringify({
        allowed,
        channel: '',
        clientVersion: this.clientVersion,
        userPermissions: userPermissions.map(up=>_.pick(up, ['scv', 'cpn', 'email', 'naturalKey', 'customerUid','naturalKeySource', 'partyId', 'permissionId']))
      })
    }).then(this.errorHandler);
  getNewsletterUri = () =>
    this.fetch(`${this.baseUri}/newsletter-uri`, {
      credentials: 'include'
    }).then(this.errorHandler);
  }


export default PermissionAPI;
